import { useEffect } from 'react';
import { BUTTON_THEMES, Form } from 'ht-styleguide';

/* Store */
import { useHomeHubStoreUserFlowAttributes } from '@scenes/HomeHub/store/client/homehub.store';

/* Queries / Mutations */
import useUserMutationResetPassword from '@store/queries/user/useUserMutation.resetPassword';

/* Hooks */
import useRouteController from '@scenes/HomeHub/hooks/hook.routeController';

/* Components */
import UserFlowHeader from '@scenes/HomeHub/pages/User/components/Header';
import { GridLayoutForm } from '@scenes/HomeHub/pages/User/components/GridLayouts';
import ButtonWrapper from '@scenes/HomeHub/pages/User/components/ButtonWrapper';
import UserFlowHeaderIcon from '@scenes/HomeHub/pages/User/components/ImageIcon';
import Typography from '@scenes/HomeHub/pages/User/components/Typography';
import SubduedText from '@scenes/HomeHub/pages/User/components/SubduedText';
import Maybe from '@components/Maybe';

/* Constants */
import { UserScreenTypes } from '@scenes/HomeHub/pages/User/index';

import styles from './user.module.scss';

const UserSetPasswordStep = () => {
  /* Queries */
  const { mutate: resetPassword, isSuccess } = useUserMutationResetPassword();

  /* Store */
  const { userEmail, firstName } = useHomeHubStoreUserFlowAttributes();

  /* Hooks */
  const { nextUserRoute } = useRouteController();

  /* Methods */
  const handleResetPassword = () => {
    resetPassword(userEmail);
  };

  useEffect(() => {
    if (isSuccess) {
      nextUserRoute(UserScreenTypes.emailPassword);
    }
  }, [isSuccess, nextUserRoute]);

  const firstNameDisplay = firstName ? `, ${firstName}` : '';

  return (
    <GridLayoutForm>
      <Form.Row classes="marginAuto width100">
        <Form.Column sm={4} md={6} mdOffset={1} lg={6} lgOffset={3} classes={styles.gridContainer}>
          <UserFlowHeaderIcon width="104" height="104" imageName="illus-lock" />
          <Maybe condition={firstNameDisplay}>
            <Typography>Welcome Back{firstNameDisplay}!</Typography>
          </Maybe>
          <UserFlowHeader classes="paddingTop-small1" headerText="Protect your information and securely access your recommendations" />
          <SubduedText classes="p1 paddingTop-tiny1">Set a password to prevent others from accessing anything you share with us.</SubduedText>
        </Form.Column>
      </Form.Row>
      <Form.Row classes="marginAuto width100">
        <Form.Column sm={4} md={6} mdOffset={1} lg={4} lgOffset={4}>
          <div className={styles.actionContainer}>
            <ButtonWrapper onClick={handleResetPassword} theme={BUTTON_THEMES.PRIMARY}>
              Set Password
            </ButtonWrapper>
          </div>
        </Form.Column>
      </Form.Row>
    </GridLayoutForm>
  );
};

export default UserSetPasswordStep;
